import axios from "axios";

export default function getAllSurahs() {
    return axios.get('https://api.alquran.cloud/v1/quran/quran-uthmani');
};
